// @ts-nocheck
import { RELEASE_NOTES_LIST_ERROR, RELEASE_NOTES_LIST_LOADING, RELEASE_NOTES_LIST_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const ReleaseNotesListReducer = (state = initialState, action) => {
    switch (action.type) {
        case RELEASE_NOTES_LIST_LOADING:
            return Object.assign({}, state, { loading: true })
        case RELEASE_NOTES_LIST_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case RELEASE_NOTES_LIST_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

